<script>
import { mapState, mapActions } from 'vuex';
import snackbarMixin from '../../mixins/snackbar';
import RbxDrawer from '../../shared/reybex/RbxDrawer';
import RbxToolbar from '../../shared/reybex/RbxToolbar';

export default {
  name: 'App',
  components: {
    RbxDrawer,
    RbxToolbar,
  },
  mixins: [snackbarMixin],
  data() {
    return {
      drawer: true,
    };
  },
  computed: {
    ...mapState('app', ['snackbar']),
    isNoLayoutPage() {
      return this.$route.meta.noLayout;
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions('app', ['hideSnackbar']),
    ...mapActions('userDetails', ['fetchCurrentUser']),
    ...mapActions('taskList', ['getAll']),
    fetchData() {
      this.getAll();
    },
  },
};
</script>

<template>
  <v-app>
    <template v-if="isNoLayoutPage">
      <router-view />
    </template>
    <template v-else>
      <rbx-drawer />
      <rbx-toolbar />
      <v-content>
        <v-container fluid class="pa-3">
          <keep-alive>
            <router-view />
          </keep-alive>
        </v-container>
      </v-content>
    </template>
    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      :timeout="snackbar.timeout"
      multi-line
    >
      {{ snackbar.text }}
      <v-icon flat dark @click="hideSnackbar">
        close
      </v-icon>
    </v-snackbar>
  </v-app>
</template>
